const $ = require("jquery");

class Stepper {
	constructor (id) {
		this.id = id;
		this.step = 0;
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getSteps () {
		return this.getRoot().find("[data-component=stepper-steps]");
	}

	getStep (i) {
		return $(this.getRoot().find("[data-component=stepper-step]")[i]);
	}

	moveToStep (i) {
		this.getStep(this.step).addClass("skew-x--12");
		this.getStep(this.step).css({display: "none"});
		this.getStep(i).removeClass("skew-x-12");
		setTimeout(() => {
			this.getStep(i).css({display: ""});
		}, 300);
		this.getSteps().css("transform", `translateX(-${i * 100}%)`);
		this.step = i;
	}

	nextStep () {
		this.moveToStep(this.step + 1);
	}
}

module.exports = Stepper;
